var exports = {
  "y": "selectPanelContainer__0pVYR2",
  "H": "validationFeedback__Tfxl_8",
};

module.exports = exports;
